module.exports = __webpack_public_path__ + "img/f739eef.svg";